import { useFetcher } from "~/hooks/useFetcher";

const { VITE_ANALYSIS_AGENT_API } = import.meta.env;

const POLL_INTERVAL_MS = 3000;

interface InitializationStatus {
  datasetId: string;
  status: "not_started" | "running" | "completed" | "failed";
  startedAt?: string;
  generatedAt?: string;
  error?: string;
  phase?: string;
  progress?: number;
}

const useInitializationStatus = (datasetId: string | undefined, enabled: boolean) => {
  const url =
    datasetId && enabled ? `${VITE_ANALYSIS_AGENT_API}/datasets/${datasetId}/initialization` : null;

  return useFetcher<InitializationStatus>(url, {
    shouldCamelize: true,
    refreshInterval: (data) => (data?.status === "running" ? POLL_INTERVAL_MS : 0),
  });
};

export default useInitializationStatus;
